import { useFilterContext } from './FilterContext';
import React, { ChangeEvent, FC, useCallback, useMemo } from 'react';
import { SearchField, SearchFieldProps } from './SearchField';

const useSearchFilter = (columnId: string) => {
  const { setFilter, getFilterValue } = useFilterContext();

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => setFilter(columnId, e.target.value),
    [setFilter, columnId],
  );

  const value = useMemo(() => getFilterValue(columnId) || '', [columnId, getFilterValue]);

  return { onChange, value };
};

export const SearchFieldFilter: FC<
  Omit<SearchFieldProps, 'onChange' & 'value'> & { columnId: string }
> = ({ columnId, ...props }) => {
  const searchProps = useSearchFilter(columnId);
  return <SearchField {...props} {...searchProps} />;
};
